import PropTypes from 'prop-types';
import { PolarAngleAxis, ResponsiveContainer, RadialBarChart, RadialBar } from 'recharts';
import { Box, useTheme } from '@mui/material';

import { DASHBOARD_DATA_KEYS } from 'constants/dashboard';
import { getDashboardColors } from 'helper/dashboardColors';
import { useBreakpointFlags } from 'hooks/useBreakpointFlags';

const styles = {
  container: (_, height) => ({
    height,
    width: '100%',
    overflow: 'hidden',
  }),
};

export const RadialChart = ({
  value = 30,
  innerRadius = 115,
  outerRadius = 205,
  barSize = 80,
  chartContainerHeight,
  chartContainerStyles = {},
}) => {
  const { palette } = useTheme();
  const { isMdUp } = useBreakpointFlags();

  const data = [
    {
      name: '0',
      value,
      max: 100,
      fill: getDashboardColors(DASHBOARD_DATA_KEYS.PERFORMANCE, value),
    },
  ];

  return (
    <Box
      sx={(theme) => ({
        ...styles.container(theme, chartContainerHeight),
        ...chartContainerStyles,
      })}
    >
      <ResponsiveContainer height={chartContainerHeight * 2}>
        <RadialBarChart
          data={data}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={180}
          endAngle={0}
          barSize={barSize}
        >
          <PolarAngleAxis type="number" domain={[0, 100]} angleAxisId={0} tick={false} />
          <RadialBar angleAxisId={0} background={{ fill: palette.colors.lightPale }} clockWise dataKey="value" />
          <g>
            <text
              x="50%"
              y="49%"
              textAnchor="middle"
              style={{
                fill: palette.text.primary,
                fontFamily: 'Poppins',
                fontWeight: 600,
                fontSize: isMdUp ? 48 : 32,
                lineHeight: isMdUp ? 1.15 : 1.5,
              }}
            >
              {value}%
            </text>
          </g>
        </RadialBarChart>
      </ResponsiveContainer>
    </Box>
  );
};

RadialChart.propTypes = {
  value: PropTypes.number,
  innerRadius: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  outerRadius: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  barSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  chartContainerStyles: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({})]),
  chartContainerHeight: PropTypes.number.isRequired,
};
